{
  "BCU$": { "title": "Current account of balance of payments, US$" },
  "CPIEOP%YR": { "title": "Consumer prices (YOY % change; end of period)" },
  "FDI$IN": { "title": "Foreign direct investment, inward, US$" },
  "FDI$OUT": { "title": "Foreign direct investment, outward, US$" },
  "GB%": { "title": "Government balance, share of GDP" },
  "GDP$!": { "title": "GDP, nominal, US$" },
  "GDP%YR": { "title": "GDP, real, annual growth" },
  "GDPHEADPPP!": { "title": "GDP per capita, PPP exchange rate, nominal, US$" },
  "GGDBT%": { "title": "Gross government debt (as a % of GDP)" },
  "GINTP": { "title": "Interest expenditure, total government, LCU" },
  "GREV": { "title": "Government revenue, total, LCU" },
  "RCB": { "title": "Interest rate, central bank official" },
  "RES$M": { "title": "Reserves, months of import cover" },
  "SP.POP.TOTL": { "title": "Population, total (in millions)" },
  "STDEBT": { "title": "External debt, short-term, US$" },
  "TDEBT$": { "title": "External debt, total, US$" },
  "X$!": { "title": "Exports, goods & services, nominal, US$" },
  "FDI$": { "title": "Foreign direct investment flows, US$" },
  "BBAL": { "title": "Basic Balance (% of GDP)" },
  "INTR": { "title": "Interest to Revenues" },
  "EDTE": { "title": "External debt to exports" },
  "SDTE": { "title": "ST External debt to exports" }
}
